import { create } from "zustand";

interface LiveRegionStore {
  politeMessage: string;
  assertiveMessage: string;
  announcePolite: (message: string) => void;
  announceAssertive: (message: string) => void;
}

let politeSeq = 0;
let assertiveSeq = 0;

/**
 * Appends an invisible unicode suffix so the screen reader re-announces
 * identical consecutive messages (aria-live only fires on content change).
 */
const uniquify = (msg: string, seq: number) =>
  msg + "\u200B".repeat(seq % 2 ? 1 : 0);

export const useLiveRegionStore = create<LiveRegionStore>()((set) => ({
  politeMessage: "",
  assertiveMessage: "",

  announcePolite: (message: string) =>
    set({ politeMessage: uniquify(message, ++politeSeq) }),

  announceAssertive: (message: string) =>
    set({ assertiveMessage: uniquify(message, ++assertiveSeq) }),
}));
